module.exports = __webpack_public_path__ + "static/assets/30c8523917f64d1f829e82c0e5562665.svg";